import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import Quality from './Quality';

const QualityCard = ({
  quality,
  qualityNotApply,
  device,
  qualityText,
  qualityStatus,
  isDuplicate,
  isPenalized,
  isPostingWithoutQuality,
  messageWithoutQuality
}) => {
  const { t } = useTranslation();
  return (
    <QualityCardContainer>
      <QualityInfo>
        <QualityCardTitle>{t('panel.desempeno.tips.adicional.titulo.posting_quality')}</QualityCardTitle>
        <QualityCardDescription
          qualityStatus={qualityStatus}
          device={device}
          isPostingWithoutQuality={isPostingWithoutQuality}
        >
          {!isPostingWithoutQuality
            ? t(`panel.desempeno.tips.adicional.bajada.posting_quality.${qualityStatus}`)
            : messageWithoutQuality.replaceAll(',', ', ')}
        </QualityCardDescription>
      </QualityInfo>
      <QualityWrapper>
        <Quality
          quality={quality}
          qualityNotApply={qualityNotApply}
          device={device}
          qualityStatus={qualityStatus}
          qualityText={qualityText}
          isTipCard
          isDuplicate={isDuplicate}
          isPenalized={isPenalized}
        />
      </QualityWrapper>
    </QualityCardContainer>
  );
};

const QualityCardContainer = styled.div`
  border: 1px solid ${select('middleGray')};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 15px;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
`;

const QualityCardTitle = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
`;

const QualityCardDescription = styled.div`
  color: ${select('darkGray')};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  white-space: pre-wrap;
  margin-top: 6px;
  overflow: auto;
  height: ${({ device, isPostingWithoutQuality }) => {
    if (device === 'mobile' && isPostingWithoutQuality) return '114px';
    if (device !== 'mobile' && isPostingWithoutQuality) return '92px';
    return 'auto';
  }};
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 32px;
    border: 8px solid ${select('midLightGray')};
  }
`;

const QualityInfo = styled.div`
  max-width: 75%;
`;

const QualityWrapper = styled.div`
  position: relative;
  width: 57px;
  height: 57px;
`;

export default QualityCard;
